import React, { useState } from 'react';
import { Grid, Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { querySaveBankAccount } from '../../../../Queries/Subscription';
import NoticeBlock from '../../../Common/NoticeBlock';
import featureFlags from '../../../../featureFlags';
import './GPIBankAccountForm.scss';

const GPIBankAccountForm = ({ cognitoSub, getBankAccounts }) => {
  const [success, setSuccess] = useState(false);
  const [GPIBankError, setGPIBankError] = useState(false);
  const [accountType, setAccountType] = useState('');
  const [routingNumber, setRoutingNumber] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [isBusinessAccount, setIsBusinessAccount] = useState(false);

  const resetFields = () => {
    setAccountType('');
    setAccountNumber('');
    setRoutingNumber('');
    setFirstName('');
    setLastName('');
    setBusinessName('');
  };

  const onSuccess = () => {
    setSuccess(true);
    resetFields();
    getBankAccounts();
    setTimeout(() => {
      setSuccess(false);
    }, 3000);
  };

  const handleSave = async () => {
    setGPIBankError('');
    const name = isBusinessAccount
      ? { business_name: businessName }
      : {
          first_name: firstName,
          last_name: lastName,
        };

    const account = {
      bank_account_number: accountNumber,
      bank_account_type: accountType,
      bank_routing_number: routingNumber,
      name,
    };

    try {
      const { errors } = await querySaveBankAccount({
        gpi_bank_account: account,
        cognitoSub,
      });
      if (errors) throw errors;

      onSuccess();
    } catch (errors) {
      console.log(errors);
      const error = errors[0].message || 'Error saving bank account';
      setGPIBankError(error);
    }
  };

  const nameIsMissing = isBusinessAccount
    ? businessName === ''
    : firstName === '' || lastName === '';
  const disableSave =
    routingNumber.length !== 9 ||
    accountNumber.length < 8 ||
    accountNumber.length > 17 ||
    accountType === '' ||
    nameIsMissing;

  const renderNameFieldsAndButton = () => {
    const displayBusinessName = featureFlags.BUSINESS_NAME && isBusinessAccount;
    const displayButton = featureFlags.BUSINESS_NAME;
    const buttonText = `Is this a ${
      displayBusinessName ? 'individual' : 'business'
    } account?`;

    const renderNameFields = () =>
      displayBusinessName ? (
        <Grid item xs={6} sm={6}>
          <TextField
            className='account-input'
            label='Business Name'
            name='business-name'
            variant='outlined'
            required
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={businessName}
            onChange={(event) => setBusinessName(event.target.value)}
          />
        </Grid>
      ) : (
        <>
          <Grid item xs={6} sm={3}>
            <TextField
            className='account-input'
              label='First Name'
              name='first-name'
              variant='outlined'
              required
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={firstName}
              onChange={(event) => setFirstName(event.target.value)}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
            className='account-input'
              label='Last Name'
              name='last-name'
              variant='outlined'
              required
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={lastName}
              onChange={(event) => setLastName(event.target.value)}
            />
          </Grid>
        </>
      );
    return (
      <>
        {renderNameFields()}
        {displayButton && (
          <button
            type='button'
            className='parkchirp--button-as-link display-type-button'
            id='account-type-btn'
            onClick={() => setIsBusinessAccount(!isBusinessAccount)}
          >
            {buttonText}
          </button>
        )}
      </>
    );
  };

  return (
    <Grid container spacing={3}>
      <>
        {renderNameFieldsAndButton()}
        <Grid item xs={12} sm={6}>
          <TextField
          className='account-input'
            label='Account #'
            name='account-number'
            variant='outlined'
            required
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={accountNumber}
            onChange={(event) => setAccountNumber(event.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
          className='account-input'
            label='Routing #'
            name='routing-number'
            variant='outlined'
            required
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={routingNumber}
            onChange={(event) => setRoutingNumber(event.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
          className='account-input'
            label='Account Type'
            name='account-type'
            variant='outlined'
            required
            fullWidth
            select
            InputLabelProps={{ shrink: true }}
            value={accountType}
            onChange={(event) => setAccountType(event.target.value)}
          >
            <MenuItem value={'CHECKING'}>Checking</MenuItem>
            <MenuItem value={'SAVINGS'}>Savings</MenuItem>
          </TextField>
        </Grid>
      </>
      <Grid item xs={12}>
        <div className='parkchirp--payment-action-button'>
          <Button
            variant='contained'
            color='primary'
            className='parkchirp--add-new-bank-account-action-button'
            onClick={handleSave}
            disabled={disableSave}
          >
            Add New Bank Account
          </Button>
          {GPIBankError && (
            <div className='parkchirp--payment-success-text'>
              <NoticeBlock
                type='error'
                containerClasses={['parkchirp--sidebar-block']}
              >
                <p>{GPIBankError}</p>
              </NoticeBlock>
            </div>
          )}
          {success && (
            <div className='parkchirp--payment-success-text'>
              <NoticeBlock
                type='message'
                containerClasses={['parkchirp--sidebar-block']}
              >
                <p>Bank account added to your account.</p>
              </NoticeBlock>
            </div>
          )}
        </div>
        <div>
          <Typography variant='caption'>
            In order to verify this account, you may see a micro charge that
            will be refunded.
          </Typography>
        </div>
      </Grid>
    </Grid>
  );
};

export default GPIBankAccountForm;
